import { useState } from "react";
import * as service from "../../../api/eventCategory.api";

export const useEventCategory = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCategoriesByOrganizer = async (companyId) => {
    setLoading(true);
    try {
      const res = await service.fetchOrganizerEventCategories(companyId);
      setCategories(res.data?.data || []);
  } catch (error) {
    setCategories([]);
  }
  };

  const loadCategories = async (company_id) => {
      setLoading(true);
      const res = await service.fetchEventCategoriesTree({ company_id });
      setData(res.data?.data || []);
      setLoading(false);
    };

  return {
    data,
    loading,
    categories,
    loadCategoriesByOrganizer,
    loadCategories,
    addCategory: service.createEventCategory,
    editCategory: service.updateEventCategory,
    deleteCategory: service.deleteEventCategory,
  };
};
